<template>

<core-content-wrapper :loading="!is.ready || is.refreshing || is.fetching === 'all'">

	<core-filter :loading="is.fetching" :filter="insightName" v-on:refresh="onRefresh">

	</core-filter>

	<core-content-page v-if="is.reset && is.fetching !== 'all'">

		<core-content-page-inner v-show="is.ready" :is-grid="true">

			<com-overview :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />

			<com-mostplays :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />

			<com-groups :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-tabs :tabs="tabs" :active="tab" v-on:change="onTabChange" />

		</core-content-page-inner>

	</core-content-page>

	<core-content-page v-if="is.reset && is.fetching !== 'all'" class="tab-content">

		<core-content-page-inner v-show="is.ready" :is-grid="true" v-if="tab === 'metrics'">
			
			<com-count :fetching="is.fetching" :your="your" :you="you" :size="3" />
			
			<com-win :fetching="is.fetching" :your="your" :you="you" :size="3" />

			<com-games :fetching="is.fetching" :your="your" :you="you" :period="period" :size="6" />
			
			<com-plays :fetching="is.fetching" :your="your" :you="you" :size="3" />
			
			<com-weight :fetching="is.fetching" :your="your" :you="you" :size="3" />
			
			<com-streaks :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />

			<com-mostgames :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />

			<com-specialised :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />

			<com-activity :fetching="is.fetching" :your="your" :you="you" :period="period" :size="6" />
			
			<com-hindex :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />

			<com-duration :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />

			<com-newcomers :fetching="is.fetching" :your="your" :you="you" :period="period" :size="2" />
			
		</core-content-page-inner>

		<core-content-page-inner v-show="is.ready" v-if="tab === 'directory'">
			
			<com-directory />
			
		</core-content-page-inner>

	</core-content-page>

</core-content-wrapper>

</template>

<script>

import Section from './common/Section.js'

import comTabs from './common/Tabs'
import comOverview from './players/Overview'
import comGroups from './players/Groups'
import comMostplays from './players/Mostplays'
import comNewcomers from './players/Newcomers'
import comActivity from './players/Activity'
import comPlays from './players/Plays'
import comWin from './players/Win'
import comWeight from './players/Weight'
import comCount from './players/Count'
import comGames from './players/Games'
import comStreaks from './players/Streaks'
import comHindex from './players/Hindex'
import comDuration from './players/Duration'
import comMostgames from './players/Mostgames'
import comSpecialised from './players/Specialised'
import comDirectory from './players/Directory'

export default {

	mixins: [Section],

	components: {
		'com-tabs': comTabs,
		'com-win': comWin,
		'com-duration': comDuration,
		'com-overview': comOverview,
		'com-mostplays': comMostplays,
		'com-newcomers': comNewcomers,
		'com-activity': comActivity,
		'com-plays': comPlays,
		'com-weight': comWeight,
		'com-count': comCount,
		'com-groups': comGroups,
		'com-games': comGames,
		'com-streaks': comStreaks,
		'com-hindex': comHindex,
		'com-mostgames': comMostgames,
		'com-specialised': comSpecialised,
		'com-directory': comDirectory
	},

	data: function() {

		return {

			insightName: 'players',
			tab: 'metrics',
			dynamicInsights: [
				'weight.band',
				'count.band',
				'count.sort',
				'count.threshold',
				'streaks.period',
				'duration.sort',
				'wins.band',
				'wins.threshold',
				'plays.band',
				'plays.threshold'
			]

		}

	},

	computed: {

		tabs: function() {

			var tabs = [
				{ value: 'metrics', text: 'Metrics' },
				{ value: 'directory', text: 'Directory' },
			]

			return tabs

		}

	},

	methods: {

		onTabChange: function(value) {

			this.tab = value

		}

	}

}

</script>

<style scoped>

.tab-content {
	padding-top: 40px!important;
}

.is-mobile .tab-content {
	padding-top: 0px!important;
}

.is-desktop .tab-content:before {
    position: absolute;
    content: '';
    display: block;
    left: -40px;
	right: -40px;
	top: 0px;
	bottom: -40px;
	background-color: #fff;
}

.is-desktop .tab-content >>> .insights-item:hover:before {
	background-color: #edf8ff;
}

</style>